import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-global-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './global-footer.html',
  styleUrls: ['./global-footer.scss'],
})
export class GlobalFooterComponent {
  currentYear = new Date().getFullYear();
}
